import { MadSDKAPIError } from "../../errors/base";
export class AiCreativePlacesFetchFailed extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError, "Failed to search places.");
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AiCreativePlacesFetchFailed);
        }
        this.name = "AiCreativePlacesFetchFailed";
    }
}
export class AiCreativeGenerateCreativesFailed extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError, "Failed to generate creatives.");
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AiCreativeGenerateCreativesFailed);
        }
        this.name = "AiCreativeGenerateCreativesFailed";
    }
}
export class AiCreativeGenerateJobStatusFailed extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError, "Failed to fetch generate-job status.");
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AiCreativeGenerateJobStatusFailed);
        }
        this.name = "AiCreativeGenerateJobStatusFailed";
    }
}
export class AiCreativeAssetDownloadFailed extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError, "Failed to download asset.");
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AiCreativeAssetDownloadFailed);
        }
        this.name = "AiCreativeAssetDownloadFailed";
    }
}
export class AiCreativeJobsFetchFailed extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError, "Failed to fetch creative jobs. Please try again at a later time.");
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AiCreativeJobsFetchFailed);
        }
        this.name = "AiCreativeJobsFetchFailed";
    }
}
//# sourceMappingURL=errors.js.map